import type { AccountHelpers } from './types';

export function useAccountHelpers(): AccountHelpers {
  const getAccountCustomFieldValueByExternalId = (
    account: CustomerAccount,
    externalId: string
  ): string | null =>
    account.customFieldValues.find((field) => field.customField.externalId === externalId)?.value ||
    null;

  return {
    getAccountCustomFieldValueByExternalId,
  };
}
